import { resetLevel2 } from '../level_2/reset_level_2';

export const onBackClick = ($nav, setCurrentNavLabel) => event => {
    resetLevel2($nav, setCurrentNavLabel);
};
